import { usePath } from '@arnold/common';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { TopicGroupTypeCode, UserQuery } from '../../generated/hooks';
import { SortOption, Topics } from '../../components/ConversationSubjects/Topics';

interface IProps {
  user: UserQuery['user'];
}

export const ChooseProcessTopicGroupScreen: FC<IProps> = ({ user }) => {
  const { type } = useParams<{ type: string }>();
  const { t } = useTranslation('onboarding');
  const { t: surveyGroupT } = useTranslation('surveyGroup');
  const {
    onboardingPath,
    exitPath,
    processSurveysPath,
    createOnboardingPath,
    createProcessSurveyPath,
    createExitPath,
  } = usePath();

  const isOnboarding = type.toLocaleLowerCase() === TopicGroupTypeCode.Onboarding.toLowerCase();
  const isExit = type.toLocaleLowerCase() === TopicGroupTypeCode.Exit.toLowerCase();
  const isProcessSurvey = !isOnboarding && !isExit;

  return (
    <Topics
      breadcrumbItems={[
        {
          title: isOnboarding
            ? t('AuthorizedPage:onboarding')
            : isExit
              ? surveyGroupT('AuthorizedPage:exit')
              : surveyGroupT('processSurveysTitle'),
          link: isOnboarding
            ? onboardingPath.createPath()
            : isExit
              ? exitPath.createPath()
              : processSurveysPath.createPath(),
        },
      ]}
      heading={isOnboarding ? t('newOnboarding') : isExit ? surveyGroupT('newExit') : surveyGroupT('newProcess')}
      dataIcom="heading-topics"
      user={user}
      hideCategoriesInFilter={true}
      hideCreateTopicButton={true}
      defaultSortOption={SortOption.UPDATED_AT_DESC}
      actionButtonText={t('topicOverview:planTopic')}
      actionButtonOnClick={(tg) => {
        if (isOnboarding) {
          createOnboardingPath.toFunc(tg.id);
        } else if (isExit) {
          createExitPath.toFunc(tg.id);
        } else {
          createProcessSurveyPath.toFunc(tg.id);
        }
      }}
      filterTopicGroups={(topicGroup) =>
        topicGroup.containsSteps &&
        ((isOnboarding && topicGroup.typeCode === TopicGroupTypeCode.Onboarding) ||
          (isExit && topicGroup.typeCode === TopicGroupTypeCode.Exit) ||
          (isProcessSurvey && topicGroup.typeCode !== TopicGroupTypeCode.Pulser))
      }
    />
  );
};
